import CarPeritajeReportEntity from "../entities/CarPeritajeReportEntity";

export default interface CarPeritajeReportRepository {
    /**
     * Trae todos los vehículos activos con su estado de peritaje resuelto.
     *
     * `onProgress` reporta el avance de las consultas por placa, que son la parte lenta:
     * la página lo usa para mostrar el progreso mientras se arma el archivo.
     */
    getActiveCarsPeritajeReport(onProgress?: (done: number, total: number) => void): Promise<CarPeritajeReportEntity[]>;
}

export const CarPeritajeReportRepositoryName = "CarPeritajeReportRepository";
